import { convertArrayObjectKeysCase, convertObjectKeysCase } from '../case/case';
import { Brand } from '../effect';
import { isArray } from '../hidash/hidash';
import type { CamelCasedPropertiesDeep } from '../types';

export const objectToStrJson = <T extends ValidJson>(json: T): string => JSON.stringify(json);
export const strToObjectJson = <T extends ValidJson>(strJson: string): T => JSON.parse(strJson);

// Have to curry to pass down the generic
// TODO (ethan): Since switching to effect, we can solve this more elegantly. Return to this to do it "correctly"
// @ts-expect-error See comment above
const makeStrJson = <T extends ValidJson>(str: string) => Brand.nominal<SerializedJson<T>>()(str);

// @ts-expect-error Doing generic branded types takes a little ts suppression
const makeObjectJson = <T extends ValidJson>(object: T) => Brand.nominal<DeserializedJson<T>>()(object);

/** Automatically will serialize camelcase to snake case */
export const serializeJson = <T extends ValidJson>(json: T) =>
  makeStrJson<T>(
    objectToStrJson(
      isArray(json) ? convertArrayObjectKeysCase(json, 'snakeCase') : convertObjectKeysCase(json, 'snakeCase'),
    ),
  ) as SerializedJson<CamelCasedPropertiesDeep<T>>;

/** Automatically will serialize snake case to camelcase */
export const deserializeJson = <T extends ValidJson>(serializedJson: SerializedJson<T>) => {
  const json = strToObjectJson(serializedJson) as T;
  return makeObjectJson(
    isArray(json) ? convertArrayObjectKeysCase(json, 'camelCase') : convertObjectKeysCase(json, 'camelCase'),
  ) as DeserializedJson<CamelCasedPropertiesDeep<T>>;
};
